import { useEffect } from 'react';

// Hooks
import useMedias from '@/utils/hooks/swr/useMedias';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import PropTypes from 'prop-types';

//Lib
import { STORY } from '@/lib/posts/postTypes';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import FilterPromotionType from '@/components/pages/myprofile/filters/FilterPromotionType';
import SelectLabels from '@/components/pages/myprofile/filters/SelectLabels';
// Components
import PostsTab from '@/components/pages/myprofile/PostsTab';

const PostsTiktokTab = ({
    isFiltersOpen,
    toggleFilters,
    isExportModalOpen,
    toggleExportModal,
    header
}) => {
    const { activeSocialProfile } = useActiveSocialProfile();

    const {
        dataMedias,
        requestParams,
        isLoadMore,
        // Loaders
        isLoadingMore,
        isLoadingInitialData,
        // Functions
        mutateMedias,
        setRequestParams,
        loadMoreMedia
    } = useMedias({
        activeSPID: activeSocialProfile?.id
    });

    // useEffect avoid to launch 2 different requests to launch medias
    useEffect(() => {
        setRequestParams((prevState) => ({
            ...prevState,
            with_labels: true,
            with_albums: true
        }));
    }, [setRequestParams]);

    return (
        <PostsTab
            isFiltersOpen={isFiltersOpen}
            toggleFilters={toggleFilters}
            isExportModalOpen={isExportModalOpen}
            toggleExportModal={toggleExportModal}
            activeSocialProfile={activeSocialProfile?.social_network_type ?? TIKTOK_BUSINESS}
            dataMedias={dataMedias}
            isLoadMore={isLoadMore}
            isLoadingMore={isLoadingMore}
            isLoadingInitialData={isLoadingInitialData}
            requestParams={requestParams}
            setRequestParams={setRequestParams}
            mutateMedias={mutateMedias}
            loadMoreMedia={loadMoreMedia}
            postFormat={STORY}
            header={header}
            renderFilters={(resetFilters, setResetFilters) => (
                <>
                    <FilterPromotionType
                        resetFilters={resetFilters}
                        stopResetFilters={() => setResetFilters(false)}
                        setRequestParams={setRequestParams}
                    />
                    <SelectLabels
                        resetFilters={resetFilters}
                        stopResetFilters={() => setResetFilters(false)}
                        setRequestParams={setRequestParams}
                        placement="bottom"
                    />
                </>
            )}
        />
    );
};

PostsTiktokTab.propTypes = {
    isFiltersOpen: PropTypes.bool,
    toggleFilters: PropTypes.func,
    isExportModalOpen: PropTypes.bool,
    toggleExportModal: PropTypes.func,
    header: PropTypes.node
};

export default PostsTiktokTab;
